import React from 'react';
import PropTypes from 'prop-types';

/**
 * NeoBadge
 * Badge / etiqueta centralizada do NeoApp. Usa classes CSS do design system
 * (_neo_components.scss) para cores e variantes — zero estilos inline.
 * Suporta visual pastificado outonado suave (padrão) ou sólido, ícones MDI e pílulas arredondadas.
 */
const NeoBadge = ({
    color = 'primary', // 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'accent' | 'chocolate' | 'muted'
    icon = null, // e.g. 'mdi-check'
    children,
    solid = false,
    className = '',
    ...props
}) => {
    const badgeClasses = [
        'neo-badge',
        `neo-badge-${color}`,
        solid ? 'neo-badge-solid' : '',
        className
    ].filter(Boolean).join(' ');

    return (
        <span className={badgeClasses} {...props}>
            {icon && <i className={`mdi ${icon} font-size-12`}></i>}
            <span>{children}</span>
        </span>
    );
};

NeoBadge.propTypes = {
    color: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'accent', 'chocolate', 'muted']),
    icon: PropTypes.string,
    solid: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.node
};

export default NeoBadge;
